module.exports = __webpack_public_path__ + "static/img/plan-4.eb127f73.png";